import React from 'react';
import { Trans } from 'react-i18next';

const defaultComponents = {
    strong: <strong />,
    em: <em />,
    ul: <ul />,
    ol: <ol className="list-decimal list-inside" />,
    li: <li className="list-disc list-inside" />,
    u: <u />,
    br: <br />,
    Link: <a href="/docs" className="text-blue-600 underline" />,
    Highlight: <span style={{ backgroundColor: '#fff3cd', padding: '2px 4px', borderRadius: '4px' }} />,
};

const TransText = ({ i18nKey, values, className, customComponents }) => (
    // <span className={className ?? "fs-4"}>
    <span>
        <Trans
            i18nKey={i18nKey}
            values={values}
            components={{ ...defaultComponents, ...customComponents }}
        />
    </span>
);

export default TransText;